import { render } from "./TripDowntimeStatuses.vue?vue&type=template&id=77c2008d&scoped=true"
import script from "./TripDowntimeStatuses.vue?vue&type=script&lang=js"
export * from "./TripDowntimeStatuses.vue?vue&type=script&lang=js"

import "./TripDowntimeStatuses.vue?vue&type=style&index=0&id=77c2008d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c2008d"]])

export default __exports__